export default __webpack_public_path__ + "static/media/fondo2.5b289016.png";